import qs from 'qs'

import { PeriodMode } from '../../../enums/periodMode'
import type { BalanceSummaryQueryParams } from '../types/balanceSummaryQueryParams'

// Shared by both sides: creditorBalanceSummary and debtorBalanceSummary take the same query params
// (AUDIT-131 freezes the debtor contract on the creditor one), only the path differs.
export const buildBalanceSummaryQueryParams = ({
  period,
  page,
  pageSize,
  sortBy,
  sortDirection,
  search,
  contactIds,
  balanceDirection,
}: BalanceSummaryQueryParams): string =>
  qs.stringify(
    {
      ...(period && period !== PeriodMode.All ? { period } : {}),
      ...(page ? { page } : {}),
      ...(pageSize ? { pageSize } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortDirection ? { sortDirection } : {}),
      ...(search ? { search } : {}),
      // The account filter keys on contactId, never on the auxiliary account number: unmapped
      // contacts have no aux number, while contactId is always present (AUDIT-256).
      ...(contactIds && contactIds.length > 0 ? { contactId: contactIds } : {}),
      ...(balanceDirection ? { balanceDirection } : {}),
    },
    { arrayFormat: 'brackets' },
  )
